import { useEffect, useState } from 'react';
import ErrorMessage from '../Elements/ErrorMessage';

// Loads data from the backend when the component mounts, and again whenever load changes: wrap load in useCallback
// with the values it depends on. A refusal the backend answers with an { error } body is returned as error; a call
// that fails shows failureMessage as an error toast. Either way the data of an earlier load stays, and isStale says
// that it is not the answer to the latest load, so that nothing is done on it as if it were.
export default function useBackendData(load, failureMessage) {
  const [data, setData] = useState(null);
  const [error, setError] = useState(null);
  const [isLoading, setIsLoading] = useState(true);
  const [isStale, setIsStale] = useState(false);

  useEffect(() => {
    // Only the answer to the latest load is kept, so a slow earlier answer cannot overwrite it.
    let isLatestLoad = true;
    setIsLoading(true);
    setError(null);
    load()
      .then((response) => {
        if (!isLatestLoad) {
          return;
        }
        if (response?.error) {
          setError(response.error);
          setIsStale(true);
          return;
        }
        setData(response);
        setIsStale(false);
      })
      .catch(() => {
        ErrorMessage.SetErrorMessage(failureMessage);
        if (isLatestLoad) {
          setIsStale(true);
        }
      })
      .finally(() => {
        if (isLatestLoad) {
          setIsLoading(false);
        }
      });
    return () => {
      isLatestLoad = false;
    };
  }, [load, failureMessage]);

  return { data, error, isLoading, isStale };
}
